import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { routesConfig } from '../routes/routesConfig';

const routeMatchesPathname = (routePath, pathname) => {
  if (routePath === pathname) return true;
  if (!routePath.includes(':')) return false;

  const routeParts = routePath.split('/').filter(Boolean);
  const pathnameParts = pathname.split('/').filter(Boolean);
  if (routeParts.length !== pathnameParts.length) return false;

  return routeParts.every((part, index) => part.startsWith(':') || part === pathnameParts[index]);
};

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    // Find the matching route
    const currentRoute = routesConfig.find(route => routeMatchesPathname(route.path, location.pathname));
    
    let pageTitle = 'KnI Wealth';
    
    if (currentRoute && currentRoute.label) {
      pageTitle = `${currentRoute.label} - KnI Wealth`;
    } else if (location.pathname === '/login') {
      pageTitle = 'Login - KnI Wealth';
    } else if (location.pathname === '/signup') {
      pageTitle = 'Sign Up - KnI Wealth';
    } else if (location.pathname === '/un-authorized') {
      pageTitle = 'Unauthorized - KnI Wealth';
    } else {
      // For 404 or any unmatched route
      pageTitle = 'Not Found - KnI Wealth';
    }
    
    document.title = pageTitle;
  }, [location.pathname]);
};

export default usePageTitle;

